/* unplugin-vue-components disabled */import { render } from "./UsersTable.vue?vue&type=template&id=1793222a&scoped=true&ts=true"
import script from "./UsersTable.vue?vue&type=script&lang=ts"
export * from "./UsersTable.vue?vue&type=script&lang=ts"

import "./UsersTable.vue?vue&type=style&index=0&id=1793222a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1793222a"]])

export default __exports__